/** Tipos para la Biblioteca de Especies en Admin */

export type WaterType = 'dulce' | 'salada' | 'both';
export type SpeciesFilter = {
    waterType: 'all' | WaterType;
    rarity: 'all' | Rarity;
};
export type Rarity = 'legendario' | 'épico' | 'raro' | 'común' | 'unknown';

export interface SpeciesCatalogEntry {
    id: number;
    scientific_name: string;
    common_names_es: string | null;
    common_names_en: string | null;
    water_type: WaterType;
    rarity: Rarity;
    image_filename: string | null;
    image_url: string | null;
    is_active: boolean;
    needs_review: boolean;
    is_in_album?: boolean;
    has_details?: boolean;
    in_cromos_album?: boolean;
    created_at?: string;
    updated_at?: string;
}

export interface SpeciesStats {
    species_catalog_id: number;
    scientific_name: string;
    capture_count: number;
    unique_anglers: number;
    cromo_unlock_count: number;
    has_details: boolean;
    in_cromos_album: boolean;
    cromos_album_display_name: string | null;
    cromos_album_rarity: string | null;
    related_count: number;
}

export type SpeciesRelationType = 'similar' | 'same_genus' | 'confusion' | 'predator_prey';

export interface SpeciesRelatedEntry {
    related_species_catalog_id: number;
    scientific_name: string;
    common_names_es: string | null;
    relation_type: SpeciesRelationType;
    created_at?: string;
}

export type CromosAlbumRarity = 'legendario' | 'épico' | 'raro' | 'común' | 'morralla';

export interface CromosAlbumEntry {
    scientific_name: string;
    display_name: string;
    water_type: 'salada' | 'dulce';
    rarity: CromosAlbumRarity;
    catalog_id: number | null;
    catalog_is_active: boolean | null;
}

export interface SpeciesCreateParams {
    p_scientific_name: string;
    p_common_names_es?: string | null;
    p_common_names_en?: string | null;
    p_water_type?: WaterType;
    p_rarity?: Rarity;
    p_image_filename?: string | null;
    p_image_url?: string | null;
    p_is_active?: boolean;
    p_needs_review?: boolean;
    p_is_in_album?: boolean;
}

export interface SpeciesUpdateParams {
    p_id: number;
    p_scientific_name?: string | null;
    p_common_names_es?: string | null;
    p_common_names_en?: string | null;
    p_water_type?: WaterType | null;
    p_rarity?: Rarity | null;
    p_image_filename?: string | null;
    p_image_url?: string | null;
    p_is_active?: boolean | null;
    p_needs_review?: boolean | null;
    p_is_in_album?: boolean | null;
}

export const WATER_TYPE_LABELS: Record<WaterType, string> = {
    dulce: 'Agua dulce',
    salada: 'Agua salada',
    both: 'Ambos',
};

export const RARITY_LABELS: Record<Rarity, string> = {
    legendario: 'Maestría legendaria',
    épico: 'Habilidad Experto',
    raro: 'Destreza limitada',
    común: 'Casualidad',
    unknown: 'Desconocido',
};
